module.exports = __webpack_public_path__ + "img/kk.7ee5686f.png";